import { mat4, quat, vec3 } from "gl-matrix";

export class Transformation {
  private scale: vec3;
  private translation: vec3;
  private readonly rotation: quat = quat.create();

  private readonly matrixCache: mat4 = mat4.create();
  private matrixCacheValid = false;

  constructor(scale: vec3, translation: vec3) {
    this.scale = scale;
    this.translation = translation;
  }

  public setScale(scale: vec3) {
    this.scale = scale;
    this.matrixCacheValid = false;
  }

  public setTranslation(translation: vec3) {
    this.translation = translation;
    this.matrixCacheValid = false;
  }

  public matrix(): mat4 {
    if (this.matrixCacheValid) {
      return this.matrixCache;
    }

    mat4.fromRotationTranslationScale(
      this.matrixCache,
      this.rotation,
      this.translation,
      this.scale,
    );

    this.matrixCacheValid = true;

    return this.matrixCache;
  }
}
